import {
    serviceEmpDashGetCirculars,
    serviceEmpDashGetDateReminders,
    serviceEmpDashGetTiles,
    serviceEmpDashGetMyUpdates,
    serviceEmpDashGetMyPerformance,
    serviceEmpDashGetSalesTarget,
    serviceEmpDashGetNotices,
    serviceEmpDashGetBenefitsImages,
    serviceInterviewCounts,
    serviceEmpDashGetEmployeeDetails,
} from "../services/EmpDashboard.service";

export const EMP_DASH_INIT              = 'EMP_DASH_INIT';
export const EMP_DASH_CIRCULAR_INIT     = 'EMP_DASH_CIRCULAR_INIT';
export const EMP_DASH_CIRCULAR_DONE     = 'EMP_DASH_CIRCULAR_DONE';
export const EMP_DASH_REMINDERS_INIT    = 'EMP_DASH_REMINDERS_INIT';
export const EMP_DASH_REMINDERS_DONE    = 'EMP_DASH_REMINDERS_DONE';
export const EMP_DASH_TILES_INIT        = 'EMP_DASH_TILES_INIT';
export const EMP_DASH_TILES_DONE        = 'EMP_DASH_TILES_DONE';
export const EMP_DASH_UPDATES_INIT      = 'EMP_DASH_UPDATES_INIT';
export const EMP_DASH_UPDATES_DONE      = 'EMP_DASH_UPDATES_DONE';
export const EMP_DASH_PERFORMANCE_INIT  = 'EMP_DASH_PERFORMANCE_INIT';
export const EMP_DASH_PERFORMANCE_DONE  = 'EMP_DASH_PERFORMANCE_DONE';
export const EMP_DASH_SALES_INIT        = 'EMP_DASH_SALES_INIT';
export const EMP_DASH_SALES_DONE        = 'EMP_DASH_SALES_DONE';
export const EMP_DASH_NOTICES_INIT      = 'EMP_DASH_NOTICES_INIT';
export const EMP_DASH_NOTICES_DONE      = 'EMP_DASH_NOTICES_DONE';
export const EMP_DASH_BENEFITS_INIT     = 'EMP_DASH_BENEFITS_INIT';
export const EMP_DASH_BENEFITS_DONE     = 'EMP_DASH_BENEFITS_DONE';
export const EMP_DASH_INTERVIEWS_INIT      = 'EMP_DASH_INTERVIEWS_INIT';
export const EMP_DASH_INTERVIEWS_DONE      = 'EMP_DASH_INTERVIEWS_DONE';
export const EMP_DASH_EMP_DETAILS_INIT     = 'EMP_DASH_EMP_DETAILS_INIT';
export const EMP_DASH_EMP_DETAILS_DONE     = 'EMP_DASH_EMP_DETAILS_DONE';

export function actionEmpDashInit() {
    return (dispatch) => {
        dispatch(actionEmpDashGetCirculars());
        dispatch(actionEmpDashGetReminders());
        dispatch(actionEmpDashGetTiles());
        dispatch(actionEmpDashGetMyUpdates());
        dispatch(actionEmpDashGetMyPerformance());
        dispatch(actionEmpDashGetSalesTarget());
        dispatch(actionEmpDashGetNotices());
        dispatch(actionEmpDashGetBenefitsImages());
        dispatch(actionEmpDashGetInterviewCounts());
        dispatch(actionEmpDashGetEmployeeDetails());
        return { type: EMP_DASH_INIT, payload: null };
    };
}

export function actionEmpDashGetCirculars() {
    const req = serviceEmpDashGetCirculars();
    return (dispatch) => {
        dispatch({ type: EMP_DASH_CIRCULAR_INIT });
        req.then((res) => {
            dispatch({ type: EMP_DASH_CIRCULAR_DONE, payload: !res.error ? res.data : [] });
        });
    };
}

export function actionEmpDashGetReminders() {
    const req = serviceEmpDashGetDateReminders();
    return (dispatch) => {
        dispatch({ type: EMP_DASH_REMINDERS_INIT });
        req.then((res) => {
            dispatch({ type: EMP_DASH_REMINDERS_DONE, payload: !res.error ? res.data : {} });
        });
    };
}

export function actionEmpDashGetTiles() {
    const req = serviceEmpDashGetTiles();
    return (dispatch) => {
        dispatch({ type: EMP_DASH_TILES_INIT });
        req.then((res) => {
            dispatch({ type: EMP_DASH_TILES_DONE, payload: !res.error ? res.data : {} });
        });
    };
}

export function actionEmpDashGetMyUpdates() {
    return (dispatch, getState) => {
        const { user } = getState().auth;
        const req = serviceEmpDashGetMyUpdates({ employee_id: user?.id });
        dispatch({ type: EMP_DASH_UPDATES_INIT });
        req.then((res) => {
            dispatch({ type: EMP_DASH_UPDATES_DONE, payload: !res.error ? res?.data?.data : [] });
        });
    };
}

export function actionEmpDashGetMyPerformance() {
    return (dispatch, getState) => {
        const { user } = getState().auth;
        const req = serviceEmpDashGetMyPerformance({ employee_id: user?.id });
        dispatch({ type: EMP_DASH_PERFORMANCE_INIT });
        req.then((res) => {
            dispatch({ type: EMP_DASH_PERFORMANCE_DONE, payload: !res.error ? res.data : null });
        });
    };
}

const SALES_DEPT_ID     = "66600f565a24d986078325a0";
const SALES_LOCATION_ID = "66ba19f1b8a637ebd883c93e";

function getCurrentFyAndMonth() {
    const now = new Date();
    const month = now.getMonth() + 1;
    const year  = now.getFullYear();
    const fy_year = month >= 4 ? `${year}-${year + 1}` : `${year - 1}-${year}`;
    return { fy_year, month };
}

export function actionEmpDashGetSalesTarget() {
    return (dispatch, getState) => {
        const { user } = getState().auth;
        const getObjId = (obj) => (typeof obj === 'object' && obj !== null ? (obj.id || obj._id) : obj);
        const deptId = getObjId(user?.department_id) || getObjId(user?.department);
        const locId = getObjId(user?.location_id) || getObjId(user?.location);

        dispatch({ type: EMP_DASH_SALES_INIT });

        if (deptId !== SALES_DEPT_ID || locId !== SALES_LOCATION_ID) {
            dispatch({ type: EMP_DASH_SALES_DONE, payload: null });
            return;
        }

        const { fy_year, month } = getCurrentFyAndMonth();
        const req = serviceEmpDashGetSalesTarget({ employee_id: user?.id, fy_year, month });
        
        req.then((res) => {
            dispatch({ type: EMP_DASH_SALES_DONE, payload: !res.error ? res.data : null });
        });
    };
}

export function actionEmpDashGetBenefitsImages() {
    const req = serviceEmpDashGetBenefitsImages();
    return (dispatch) => {
        dispatch({ type: EMP_DASH_BENEFITS_INIT });
        req.then((res) => {
            dispatch({ type: EMP_DASH_BENEFITS_DONE, payload: !res.error ? res.data : [] });
        });
    };
}

export function actionEmpDashGetInterviewCounts() {
    return (dispatch, getState) => {
        const { user } = getState().auth;
        const req = serviceInterviewCounts({ interviewer_id: user?.id });
        dispatch({ type: EMP_DASH_INTERVIEWS_INIT });
        req.then((res) => {
            dispatch({ type: EMP_DASH_INTERVIEWS_DONE, payload: !res.error ? res.data : null });
        });
    };
}

export function actionEmpDashGetEmployeeDetails() {
    return (dispatch, getState) => {
        const { user } = getState().auth;
        const req = serviceEmpDashGetEmployeeDetails({ code: user?.emp_code });
        dispatch({ type: EMP_DASH_EMP_DETAILS_INIT });
        req.then((res) => {
            dispatch({ type: EMP_DASH_EMP_DETAILS_DONE, payload: !res.error ? res.data : null });
        });
    };
}

export function actionEmpDashGetNotices() {
    return (dispatch, getState) => {
        const { user } = getState().auth;
        const req = serviceEmpDashGetNotices({ employeeId: user?.id, index: 1, row: "createdAt", order: "desc", query: "", query_data: [] });
        dispatch({ type: EMP_DASH_NOTICES_INIT });
        req.then((res) => {
            dispatch({ type: EMP_DASH_NOTICES_DONE, payload: !res.error ? (Array.isArray(res.data) ? res.data : res.data?.data) : [] });
        });
    };
}
